const getPopupPositionProperties = ({ width = 600, height = 700 } = {}) => {
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;
  return `left=${left},top=${top},width=${width},height=${height}`;
};

interface OAuthCallbackMessage {
  from: string;
  success: boolean;
  error: any;
  code: any;
  state?: any;
}

type CallbackHandler = (data: OAuthCallbackMessage) => any;
type OnPopupClose = () => any;

export class OAuthPopup {
  private handler?: CallbackHandler;

  private popupClosed?: OnPopupClose;

  private popup?: Window | null;

  private interval?: number;

  private provider?: string;

  private boundedListenProvider: any;

  constructor() {
    this.boundedListenProvider = this.listenProvider.bind(this);
  }

  onCallback(handler: CallbackHandler) {
    this.handler = handler;
    return this;
  }

  onPopupClosed(handler: OnPopupClose) {
    this.popupClosed = handler;
    return this;
  }

  init(authorizationUrl: string, provider: string) {
    this.provider = provider;
    this.cleanUp();

    window.addEventListener('message', this.boundedListenProvider, false);

    this.popup = window.open(authorizationUrl, '_blank', getPopupPositionProperties());
    this.interval = window.setInterval(this.watchPopupClosed.bind(this), 1000);
  }

  cleanUp() {
    if (this.popup) this.popup.close();
    if (this.interval) window.clearInterval(this.interval);

    window.removeEventListener('message', this.boundedListenProvider, false);
    this.interval = undefined;
  }

  private watchPopupClosed(): void {
    if (this.popup && this.popup.closed) {
      this.cleanUp();

      if (this.popupClosed) this.popupClosed();
    }
  }

  private listenProvider(event: MessageEvent) {
    const { from } = event.data;

    if (from === this.provider) {
      this.cleanUp();
      if (!this.handler) return;
      this.handler(event.data);
    }
  }
}

export default new OAuthPopup();
